export const PURCHASE_SPLIT = {
  FULL_AMOUNT: "FULL_AMOUNT",
  RESTAURANT_PERCENTAGE: "RESTAURANT_PERCENTAGE",
  CUSTOM_PERCENTAGE: "CUSTOM_PERCENTAGE",
};
